import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';
import {omitEmptyParameterFields} from './table-report-query-params-utils';

const rootSelector = (state: TAppState) => state[TABLE_REPORT_SLICE];

export const selectTableReportQueryParameters = createSelector(
    rootSelector, ({queryParameters}) => queryParameters,
);

export const selectTableReportRawDefaultQueryParams = createSelector(
    selectTableReportQueryParameters,
    ({defaultParameters}) => defaultParameters,
);

export const selectTableReportRawQueryParams = createSelector(
    selectTableReportQueryParameters,
    ({parameters}) => parameters,
);

export const selectTableReportQueryParams = createSelector(
    selectTableReportRawQueryParams,
    parameters => omitEmptyParameterFields(parameters),
);

export const selectTableReportDefaultQueryParams = createSelector(
    selectTableReportRawDefaultQueryParams,
    defaultParameters => omitEmptyParameterFields(defaultParameters),
);
